export const SOFTPHONE_POPOUT_STORAGE_KEY = 'softphone-popout-position';
export const SOFTPHONE_POPOUT_WIDTH = 310;
export const SOFTPHONE_POPOUT_MIN_HEIGHT = 500;
export const SOFTPHONE_POPOUT_BOTTOM_SAFE_AREA = 4;
